import { Box } from "@mui/material";
import RegistryFields from "./RegistryFields";
import CustomizedFields from "./CustomizedFields";

export default function CreateRegistryStepTwo() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      flex={1}
      minHeight={0}
    >
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
        mt={1.5}
        mx={3}
        gap={2}
        minHeight={0}
      >
        <RegistryFields />
        <CustomizedFields />
      </Box>
    </Box>
  );
}